import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    ArrowLeftRight,
    PlusCircle,
    ThreeDotsVertical,
} from "react-bootstrap-icons";
import Tabs from "../../../Shared/Tab/Tab";
import PageHeader from "../../../Layout/PageHeader";
import {
  packCompleteData,
  packInProgressData,
    readytoPackdata,
} from "../../../Data/outbound";
import Table, { Column } from "../../../Components/Tables/Table";

export default function PackOverview() {
  const pageName = "Pack";

  const handleGlobalFilter = () => {
    setShowCanvas(!isShowCanvas);
  };
  const handleGlobalSearch = () => {};

  const onCurrentPageChange = (page: number) => {
    // Handle page change here if needed
    console.log("Page changed to:", page);
  };

  const columns: Column[] = [
    {
      name: "Shipment #",
      selector: (row: { shipment: string }) => (
        <span
          className="cursor-pointer text-primary"
          onClick={() => handleRowClick(row?.shipment)}
        >
          {row.shipment}
        </span>
      ),
      enableSorting: true,
    },
    {
      name: "Ship-to",
      selector: (row: { shipTo: string }) => row.shipTo,
      enableSorting: true,
    },
    {
      name: "Pack Method",
      selector: (row: { packMethod: string }) => row.packMethod,
      enableSorting: true,
    },
    {
      name: "Shipment Qty",
      selector: (row: { shipmentQty: number }) => row.shipmentQty,
      enableSorting: true,
    },
    {
      name: "Picked Qty",
      selector: (row: { pickedQty: number }) => row.pickedQty,
      enableSorting: true,
    },
    {
      name: "Packing Qty",
      selector: (row: { packingQty: number }) => row.packingQty,
      enableSorting: true,
    },
    {
      name: "Pack Area",
      selector: (row: { packArea: string }) => row.packArea,
      enableSorting: true,
    },
    {
      name: "Status",
      selector: (row: { status: string }) => {
        let badgeClass = "badge asn-overview-status ";
  
        switch (row.status) {
          case "Ready To Pack":
            badgeClass += "asn-overview-status-border-purple";
            break;
          case "Pack In Progress":
            badgeClass += "asn-overview-status-border-orange";
            break;
          case "Pack Complete":
            badgeClass += "asn-overview-status-border-green";
            break;
          default:
            badgeClass += "asn-overview-status-border-gray"; // Default styling
        }
  
        return <span className={badgeClass}>{row.status}</span>;
      },
      enableSorting: true,
    },
    {
      name: (
        <>
          <ArrowLeftRight
            className="me-2"
            style={{ stroke: "black", strokeWidth: 1 }}
          />
          <PlusCircle style={{ stroke: "black", strokeWidth: 1 }} />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none ms-4"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items">
            <li className="cursor-pointer ms-3 mb-1" onClick={() => handleRowClick(row?.shipment)}>
              View
            </li>
            {/* <li className="cursor-pointer ms-3 mb-1">
              Assign
            </li>
            <li className="cursor-pointer ms-3 mb-1">
              Start Packing
            </li> */}
          </ul>
        </>
      ),
      enableSorting: false, // Disable sorting for this column
    },
  ];
  

  const [isShowCanvas, setShowCanvas] = useState(false);
  const navigation = useNavigate();

  const handleRowClick = (data: any) => {
    return navigation(`/outbound/pack/details/${data}`);
  };
  const tabs = [
    {
      order: 0,
      label: "Ready To Pack | " + readytoPackdata.length,
      content: (
        <Table
          columns={columns}
          customClassName="out-bound-table-header sph-table-color"
          enableSorting={true}
          CheckboxStatus={false}
          data={readytoPackdata}
          pagination={{
            recordsPerPage: 12,
            totalRecords: readytoPackdata.length,
            onCurrentPageChange: onCurrentPageChange,
          }}
        />
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Pack In Progress | " + packInProgressData.length,
      content: (
        <Table
          columns={columns}
          data={packInProgressData}
          customClassName="out-bound-table-header sph-table-color"
          enableSorting={true}
          CheckboxStatus={false}
          pagination={{
            recordsPerPage: 15,
            totalRecords: packInProgressData.length,
            onCurrentPageChange: onCurrentPageChange,
          }}
        />
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Pack Complete | " + packCompleteData.length,
      content: (
        <Table
          columns={columns}
          data={packCompleteData}
          customClassName="out-bound-table-header sph-table-color"
          enableSorting={true}
          CheckboxStatus={false}
          pagination={{
            recordsPerPage: 15,
            totalRecords: packCompleteData.length,
            onCurrentPageChange: onCurrentPageChange,
          }}
        />
      ),
      visibility: true,
      status: true,
    },
  ];
  return (
    <>
      <PageHeader
      hideAddButton={true}
        handleGlobalFilter={handleGlobalFilter}
        handleGlobalSearch={handleGlobalSearch}
        listUrl="/outbound/pack/overview"
      />

      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="inbound-CheckIn-Table-Main-Div"></div>
      <div>
        <Tabs tabs={tabs} isCheckbox={true} />
      </div>
    </>
  );
}
